/* src/app/modules_v2/booking/components/booking-activation-required-dialog/booking-activation-required-dialog.component.css */
.activation-required-dialog {
  padding: 0;
  max-width: 500px;
}
::ng-deep .ard-dialog-panel.mat-mdc-dialog-panel .mat-mdc-dialog-surface.mdc-dialog__surface {
  border-radius: 20px !important;
}
.ard-header {
  position: relative;
  overflow: hidden;
  background:
    linear-gradient(
      135deg,
      #6fa524 0%,
      var(--cf-brand-dark, #4d7a00) 55%,
      #304f00 100%);
  padding: 36px 28px 30px;
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}
.ard-header__glow {
  position: absolute;
  top: -70px;
  right: -50px;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background:
    radial-gradient(
      circle,
      rgba(255, 255, 255, .28) 0%,
      rgba(255, 255, 255, 0) 70%);
  pointer-events: none;
}
.ard-header__badge {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .16);
  border: 1px solid rgba(255, 255, 255, .35);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .15);
  animation: ard-float 3s ease-in-out infinite;
}
.ard-header__badge mat-icon {
  font-size: 30px;
  width: 30px;
  height: 30px;
  color: #fff;
}
@keyframes ard-float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}
.ard-header__eyebrow {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  background: rgba(255, 255, 255, .18);
  padding: 4px 12px;
  border-radius: 999px;
}
.ard-header__title {
  margin: 4px 0 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
  font-family:
    "Bricolage Grotesque",
    "Inter Tight",
    sans-serif;
}
.ard-header__subtitle {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  opacity: .92;
  max-width: 360px;
}
.ard-body {
  padding: 24px 24px 8px;
  max-height: calc(80vh - 190px);
  overflow-y: auto;
  background: var(--cf-bg, #f4f6f8);
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.ard-trial {
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  background: var(--cf-brand-light, #fff4e5);
  border: 1px solid var(--cf-brand-border, #ffe0b3);
  border-radius: var(--cf-radius-lg, 12px);
  padding: 16px 18px;
  overflow: hidden;
}
.ard-trial__ribbon {
  position: absolute;
  top: 10px;
  right: -30px;
  transform: rotate(40deg);
  background: var(--cf-brand-dark, #d48f00);
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
  padding: 3px 34px;
}
.ard-trial__icon {
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: var(--cf-shadow-sm, 0 1px 3px rgba(0, 0, 0, .08));
}
.ard-trial__icon mat-icon {
  color: var(--cf-brand-dark, #d48f00);
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.ard-trial__text h3 {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 700;
  color: var(--cf-text, #1a1d23);
}
.ard-trial__text p {
  margin: 0;
  font-size: 12.5px;
  color: var(--cf-text-muted, #6b7280);
  line-height: 1.5;
}
.ard-features__title {
  display: block;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .04em;
  color: var(--cf-text-muted, #6b7280);
  margin-bottom: 10px;
}
.ard-features__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}
.ard-feature {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--cf-surface, #fff);
  border: 1px solid var(--cf-border, #e5e7eb);
  border-radius: var(--cf-radius-lg, 12px);
  padding: 12px;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--cf-text, #1a1d23);
  transition:
    transform .18s ease,
    box-shadow .18s ease,
    border-color .18s ease;
}
.ard-feature:hover {
  transform: translateY(-2px);
  box-shadow: var(--cf-shadow-sm, 0 1px 3px rgba(0, 0, 0, .08));
  border-color: var(--cf-brand-border, #ffe0b3);
}
.ard-feature__icon {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: rgba(227, 253, 100, .35);
  display: flex;
  align-items: center;
  justify-content: center;
}
.ard-feature__icon mat-icon {
  font-size: 17px;
  width: 17px;
  height: 17px;
  color: var(--cf-success, #16a34a);
}
.ard-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 18px 24px;
  border-top: 1px solid var(--cf-border, #e5e7eb);
  background: var(--cf-surface, #fff);
}
.ard-btn-cancel {
  color: var(--cf-text-muted, #6b7280);
  font-weight: 500;
  text-transform: none;
  font-size: 14px;
}
.ard-btn-cancel:hover {
  background-color: rgba(0, 0, 0, .04);
  color: #444;
}
.ard-btn-activate {
  background:
    linear-gradient(
      135deg,
      #e3fd64 0%,
      #c9e64a 100%) !important;
  color: #1e1e1e !important;
  font-weight: 700;
  text-transform: none;
  font-size: 14px;
  padding: 8px 22px;
  border-radius: var(--cf-radius-lg, 12px);
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 168px;
  justify-content: center;
  box-shadow: 0 4px 14px rgba(201, 230, 74, .45);
  transition: transform .2s ease, box-shadow .2s ease;
}
.ard-btn-activate mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.ard-btn-activate:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(201, 230, 74, .55);
}
.ard-btn-activate:active {
  transform: translateY(0);
}
@media (max-width: 600px) {
  .ard-header {
    padding: 28px 20px 24px;
  }
  .ard-header__title {
    font-size: 19px;
  }
  .ard-body {
    padding: 20px 18px 4px;
  }
  .ard-features__grid {
    grid-template-columns: 1fr;
  }
  .ard-actions {
    padding: 14px 18px;
    flex-direction: column-reverse;
  }
  .ard-btn-activate,
  .ard-btn-cancel {
    width: 100%;
    min-width: auto;
  }
}
@media (prefers-reduced-motion: reduce) {
  .ard-header__badge {
    animation: none;
  }
}
/*# sourceMappingURL=booking-activation-required-dialog.component.css.map */
